// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3C1Le","unreadBadge":"styles_unreadBadge__3HLao","modalContent":"styles_modalContent__UXBoY","modal":"styles_modal__33Yb6"};